import React, { Suspense, useState } from "react";
import PropTypes from "prop-types";
import HeaderShimmer from "./Header/Header.shimmer";
const Header = React.lazy(() => import("./Header/Header"));
const Footer = React.lazy(() => import("./Footer/footer"));
import classes from "./index.module.css";
import bookLogo from "../../assets/images/book.webp";
import { Link } from "react-router-dom";
const FeedbackForm = React.lazy(() =>
  import("../../components/Feedback/FeedbackForm")
);
import { useMegaMenu } from "../../Pregrine/MegaMenu/useMegaMenu";
import { useCartTrigger } from "../../Pregrine/cartTrigger/useCartTrigger";
import { GET_ITEM_COUNT_QUERY } from "../../Pregrine/cartTrigger/cartTrigger.gql";

const Layout = ({ children }) => {
  const [showFeedback, setShowFeedback] = useState(false);
  const talons = useMegaMenu();
  const { itemCount } = useCartTrigger({
    queries: {
      getItemCountQuery: GET_ITEM_COUNT_QUERY,
    },
  });
  const { MegaMenuData, categoryData } = talons;

  return (
    <>
      <main className={classes.root}>
        <Suspense fallback={<HeaderShimmer />}>
          <Header
            MegaMenuData={MegaMenuData}
            categoryData={categoryData}
            itemCount={itemCount}
          />
        </Suspense>
        <div className={classes.page}>{children}</div>

        <Suspense fallback={null}>
          <Footer MegaMenuData={MegaMenuData} />
        </Suspense>
      </main>
      <div className={classes.leftbutton}>
        <button
          className={`btn ${classes.btnbulk} ${classes.toggle1}`}
          data-bs-toggle="offcanvas"
          data-bs-target="#offcanvasRight"
          aria-controls="offcanvasRight"
          onClick={() => setShowFeedback(true)}
        >
          <Link className="">Feedback</Link>
        </button>
        <button className={`btn ${classes.btnshop}`}>
          <Link to="/catalogue" className="">
            Catalogue{" "}
            <img src={bookLogo} alt="catalogue" width={19} height={19} />
          </Link>
        </button>
      </div>
      <div
        className="offcanvas offcanvas-end"
        tabIndex="-1"
        id="offcanvasRight"
        aria-labelledby="offcanvasRightLabel"
      >
        <Suspense fallback={null}>
          {showFeedback ? (
            <FeedbackForm setShowFeedback={setShowFeedback} />
          ) : null}
        </Suspense>
      </div>
    </>
  );
};

Layout.propTypes = {
  children: PropTypes.object.isRequired,
};

export default Layout;
